import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-reply",
  templateUrl: "./med-icon-reply.component.html",
})
export class MedIconReplyComponent extends SvgMixinComponent {}
